export class MissingKeyError extends Error {
    constructor(key) {
        super(`Missing key value: ${key} (no default value specified)`);
        this.name = 'MissingKeyError';
    }
}
